<template>
  <div>
    <section-separator v-if="showLabel"
                       class="group-separator mb-2">
      <span>{{$t('language.text.languageSelect')}}</span>
      <tooltip-icon-button icon="fas fa-question"
                           class="ml-2 info-button"
                           round
                           :content="$t('language.text.languageSelect.tip')">
      </tooltip-icon-button>
    </section-separator>
    <language-select v-model="selectedLocale" @change="onLanguageChange" size="small"/>
  </div>
</template>
<script>
  import TooltipIconButton from 'src/components/Buttons/TooltipIconButton'
  import LanguageSelect from 'src/components/LanguageSelect'
  import { setLocaleHeader } from 'src/services/apiConfig'

  export default {
    components: {
      LanguageSelect,
      TooltipIconButton
    },
    props: {
      showLabel: {
        type: Boolean,
        default: true,
      }
    },
    data () {
      return {
        selectedLocale: this.$store.state.config.textLanguage || 'en',
      }
    },
    methods: {
      onLanguageChange (newLang) {
        setLocaleHeader(newLang)
        this.$store.commit('config/SET_TEXT_LANGUAGE', newLang)
      }
    }

  }
</script>
<style lang="scss">
  .info-button.btn.btn-icon{
    width: 20px;
    height: 20px;
    min-width: 20px;
    i {
      font-size: 10px;
    }
  }
</style>
